'use strict';
module.exports = function (str) {
	var tail = str.length;

	while (/[\s\uFEFF\u00A0]/.test(str[tail - 1])) {
		tail--;
	}

	return str.slice(0, tail);
};



//////////////////
// WEBPACK FOOTER
// ./~/trim-right/index.js
// module id = 3996
// module chunks = 0